import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

export default function EmptyState({ type = 'no-results', onClear, description, message }) {
    const { t } = useTranslation("global");
    const states = {
        'no-results': {
            icon: <SearchOffIcon sx={{ fontSize: 80, color: '#9CA3AF' }} />,
            title: t("empty.no_ordenes_title"),
            description: t("empty.no_ordenes_desc"),
            action: t("empty.limpiar")
        },
        'no-data': {
            icon: <FilterListOffIcon sx={{ fontSize: 80, color: '#9CA3AF' }} />,
            title: t("empty.no_ordenes_title"),
            description: t("empty.no_hay_ordenes_desc"),
            action: null
        }
    };

    const state = states[type] || states['no-results'];
    const displayDescription = message || description || state.description;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 8,
                px: 2
            }}
        >
            {state.icon}
            <Typography variant="h6" sx={{ mt: 2, color: '#374151', fontWeight: 600 }}>
                {state.title}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: '#6B7280', textAlign: 'center', maxWidth: 400 }}>
                {displayDescription}
            </Typography>
            {state.action && onClear && (
                <Button
                    variant="contained"
                    onClick={onClear}
                    sx={{ mt: 3, backgroundColor: '#BD1F34' }}
                >
                    {state.action}
                </Button>
            )}
        </Box>
    );
}
